import React from 'react';
import Markdown from 'react-markdown';

interface ModalHyperlinkMarkdownProps {
	content: string;
	handleMDLinkClick: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

const hyperlinkStyle = {
	fontWeight: 'bold',
	cursor: 'pointer',
	textDecoration: 'underline',
	color: 'inherit'
};

const ModalHyperlinkMarkdown: React.FC<ModalHyperlinkMarkdownProps> = ({ content, handleMDLinkClick }) => {
	const handleKeyDown = (event: React.KeyboardEvent<HTMLAnchorElement>) => {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			handleMDLinkClick(event as unknown as React.MouseEvent<HTMLAnchorElement>);
		}
	};

	const components = {
		a: ({ children, ...props }: React.AnchorHTMLAttributes<HTMLAnchorElement>) => {
			const href = props.href;

			return (
				<a
					{...props}
					onClick={handleMDLinkClick}
					onKeyDown={handleKeyDown}
					data-href={href}
					tabIndex={0}
					role="link"
					style={hyperlinkStyle}
				>
					{children}
				</a>
			);
		}
	};

	return (
		<Markdown className="custom-markdown" components={components}>
			{content}
		</Markdown>
	);
};

export default ModalHyperlinkMarkdown;
